export const general_discussion = "Discussion générale";
export const creator_spotlight = "Focus sur les créateurs";
export const reviews = "Critiques";
export const recommendations = "Recommandations";
export const news_updates = "Actualités et mises à jour";
export const behind_scenes = "Coulisses";
export const create_post = "Créer une publication";
export const write_review = "Écrire une critique";
export const ask_recommendation = "Demander une recommandation";
export const share_news = "Partager des nouvelles";
export const share_story = "Partager une histoire";
export const post_title = "Titre de la publication";
export const post_content = "Contenu de la publication";
export const select_category = "Sélectionner une catégorie";
export const add_tags = "Ajouter des étiquettes";
export const upload_image = "Télécharger une image";
export const publish = "Publier";
export const draft = "Brouillon";
export const preview = "Aperçu";
export const edit_post = "Modifier la publication";
export const delete_post = "Supprimer la publication";
export const pin_post = "Épingler la publication";
export const unpin_post = "Désépingler la publication";
export const lock_post = "Verrouiller la publication";
export const unlock_post = "Déverrouiller la publication";
export const report_post = "Signaler la publication";
export const mark_solved = "Marquer comme résolu";
export const mark_unsolved = "Marquer comme non résolu";
export const upvote = "Vote positif";
export const downvote = "Vote négatif";
export const bookmark = "Marquer";
export const unbookmark = "Supprimer le marque-page";
export const sort_by = "Trier par";
export const filter_by = "Filtrer par";
export const most_recent = "Plus récent";
export const most_popular = "Plus populaire";
export const most_voted = "Plus voté";
export const most_commented = "Plus commenté";
export const solved_only = "Résolus seulement";
export const unsolved_only = "Non résolus seulement";
export const pinned_posts = "Publications épinglées";
export const locked_posts = "Publications verrouillées";
export const no_posts_found = "Aucune publication trouvée";
export const no_comments_found = "Aucun commentaire trouvé";
export const write_comment = "Écrire un commentaire";
export const reply_to_comment = "Répondre au commentaire";
export const edit_comment = "Modifier le commentaire";
export const delete_comment = "Supprimer le commentaire";
export const report_comment = "Signaler le commentaire";
export const comment_placeholder = "Écrivez votre commentaire ici...";
export const reply_placeholder = "Écrivez votre réponse ici...";
export const search_posts = "Rechercher des publications";
export const search_placeholder = "Rechercher des publications et des sujets...";
export const forum_rules = "Règles du forum";
export const community_guidelines = "Directives de la communauté";
export const moderator = "Modérateur";
export const admin = "Administrateur";
export const verified_user = "Utilisateur vérifié";
export const new_member = "Nouveau membre";
export const active_member = "Membre actif";
export const senior_member = "Membre senior";
export const reputation_points = "Points de réputation";
export const join_date = "Date d'inscription";
export const last_seen = "Dernière visite";
export const posts_count = "Nombre de publications";
export const comments_count = "Nombre de commentaires";
export const likes_received = "J'aime reçus";
export const forum_stats = "Statistiques du forum";
export const total_posts = "Total des publications";
export const total_comments = "Total des commentaires";
export const total_members = "Total des membres";
export const active_today = "Actif aujourd'hui";
export const trending_topics = "Sujets tendance";
export const popular_tags = "Étiquettes populaires";
export const recent_activity = "Activité récente";